import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.triggered = false;
        window.addEventListener('scroll', () => {
            let scrollY = window.scrollY;
            if (scrollY > window.innerHeight / 2 && scrollY < window.innerHeight / 2 + 100) {
                if (!this.triggered) {
                    this.el.classList.remove('is-minimized');
                    this.triggered = true;
                }
            }
        });
    }
}
